import { DELIVERY_STATE } from '@theailab-dev/parchment';
import type { DeliveryState } from '@theailab-dev/parchment';
import type { BadgeVariant } from '@/components/ui/Badge';

const DELIVERY_STATE_BADGE_VARIANT: Record<DeliveryState, BadgeVariant> = {
  [DELIVERY_STATE.ORDERED]: 'neutral',
  [DELIVERY_STATE.PREPARING]: 'neutral',
  [DELIVERY_STATE.SHIPPED]: 'indigo',
  [DELIVERY_STATE.IN_TRANSIT]: 'orange',
  [DELIVERY_STATE.DELIVERED]: 'success',
  [DELIVERY_STATE.CANCELED]: 'danger',
};

export function getDeliveryStateBadgeVariant(state: DeliveryState | string): BadgeVariant {
  if (state in DELIVERY_STATE_BADGE_VARIANT) {
    return DELIVERY_STATE_BADGE_VARIANT[state as DeliveryState];
  }

  return 'neutral';
}
